export const data = () => ({
  isDebug: true,
  loading: false,
  vendorRequestID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
